export function extractTokenExpiryAndIssuedAt(jwtToken: string) {
	if (!jwtToken) {
		throw new Error("Invalid JWT token provided");
	}

	const parts = jwtToken.split(".");
	if (parts.length !== 3) {
		throw new Error("Invalid JWT token format");
	}

	try {
		// Decode the payload part (base64url)
		const payload = JSON.parse(
			atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")),
		);

		// Extract 'exp' and 'iat' fields
		const { exp, iat } = payload;

		if (typeof exp === "undefined" || typeof iat === "undefined") {
			throw new Error("Token does not contain exp or iat fields");
		}

		return {
			expiry: new Date(exp * 1000), // Convert to milliseconds and create a Date object
			issuedAt: new Date(iat * 1000), // Convert to milliseconds and create a Date object
		};
	} catch (error) {
		throw new Error(`Failed to decode JWT token: ${(error as Error).message}`);
	}
}
